import React, { useState } from 'react';
import { Stack, TextField } from '@mui/material';

import { MainContainer } from '../../styles/styles';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import ActionButton from '../../presentation/components/ActionButton/ActionButton';
import { useSurveyRedCertStore } from '../../stores/storeRoot';
import SurveyFormModal from '../../presentation/features/common_modals/SurveyFormModal/SurveyFormModal';
import {
  ButtonContainer,
  DevInfoContainer,
  DevInfoText,
  FormHeaderBar,
  FormHeaderTitle,
  TestingToolContainer,
  TestingToolTitle,
} from './styles';

const Playground: React.FC = () => {
  const [surveyId, setSurveyId] = useState('');
  const [isSurveyModalOpen, setIsSurveyModalOpen] = useState(false);
  const [surveyName, setSurveyName] = useState('');
  const [surveyFormData, setSurveyFormData] = useState(null);
  const { getSurveyFormForSurvey } = useSurveyRedCertStore();
  const [errorMessage, setErrorMessage] = useState('');

  const handleOpenSurveyModal = async () => {
    if (!surveyId.trim()) {
      setErrorMessage('Please enter a survey ID');
      return;
    }

    try {
      setErrorMessage('');
      const getSurveyFormResponse = await getSurveyFormForSurvey(surveyId);

      if (getSurveyFormResponse?.data) {
        setSurveyName(getSurveyFormResponse.data.surveyName);
        setSurveyFormData({
          questions: getSurveyFormResponse.data.questions,
          additionalData: getSurveyFormResponse.data.additionalData || {},
          filledBy: getSurveyFormResponse.data.filledBy,
          answers: getSurveyFormResponse.data.answers,
          filledOut: getSurveyFormResponse.data.filledOut,
          surveyAdditionalData: getSurveyFormResponse.data.surveyAdditionalData,
        });

        setIsSurveyModalOpen(true);

        if (typeof window !== 'undefined' && window.document) {
          document.body.style.overflow = 'hidden';
        }
      }
    } catch (error) {
      console.error('Error fetching survey form:', error);
      setErrorMessage(
        'Unable to retrieve survey. Please check the ID and try again.'
      );
    }
  };

  return (
    <MainContainer>
      <PageHeader title="Developers playground" />

      <DevInfoContainer>
        <DevInfoText>
          <strong>Developer Testing Area</strong> - This page is intended for
          developers to test various functionalities without affecting
          production data.
        </DevInfoText>
      </DevInfoContainer>

      <TestingToolContainer elevation={3}>
        <Stack spacing={3}>
          <TestingToolTitle variant="h6">
            Survey / RedCert Testing Tool
          </TestingToolTitle>

          <TextField
            fullWidth
            label="Survey ID"
            variant="outlined"
            value={surveyId}
            onChange={(e) => setSurveyId(e.target.value)}
            error={!!errorMessage}
            helperText={errorMessage}
          />
          <ButtonContainer>
            <ActionButton
              variant="accept"
              buttonText="Open Survey"
              onClickAction={handleOpenSurveyModal}
            />
          </ButtonContainer>
        </Stack>
      </TestingToolContainer>

      {isSurveyModalOpen && surveyFormData && (
        <>
          <FormHeaderBar>
            <FormHeaderTitle variant="h6">RedCert Form</FormHeaderTitle>
          </FormHeaderBar>

          <SurveyFormModal
            open={isSurveyModalOpen}
            onClose={() => {
              setIsSurveyModalOpen(false);
              document.body.style.overflow = 'overlay';
            }}
            surveyName={surveyName}
            questions={surveyFormData.questions || []}
            surveyId={surveyId}
            filledBy={surveyFormData.filledBy}
            additionalProperties={surveyFormData.surveyAdditionalData}
            invekosNumber={surveyFormData.additionalData?.invekosno || ''}
            onSubmitSuccess={() => {
              setIsSurveyModalOpen(false);
              document.body.style.overflow = 'overlay';
              alert('Survey submitted successfully!');
            }}
            previousAnswers={surveyFormData.answers}
            isFilledOut={surveyFormData.filledOut}
          />
        </>
      )}
    </MainContainer>
  );
};

export default Playground;
